import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { ApplicationPage } from "./ApplicationPage";
import { SuspenseWrapper } from "./shared/components/SuspenseWrapper";
import {
    useMediaQuery,
    useTheme
} from "@mui/material";
import MobileLoginPage from "./features/authentication/components/MobileLoginPage";

const LoginPage = lazy(() => import('./features/authentication/components/LoginPage'));
const SignupPage = lazy(() => import('./features/authentication/components/SignupPage'));
const ForumPage = lazy(() => import('./features/forum/components/forum-page/ForumPage'));

function App() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    return (
        <Routes>
            <Route path="/login/*" element={isMobile ? <MobileLoginPage/> : <SuspenseWrapper component={<LoginPage/>} />} />
            <Route path="/signup/*" element={<SuspenseWrapper component={<SignupPage/>} />} />
            <Route path="/forum/*" element={<SuspenseWrapper component={<ForumPage />} />} />
            <Route path='/*' element={<ApplicationPage/>} />
        </Routes>
    );
}

export default App;